<template>
  <section class="insider-page">
    <div class="insider-page__header">
      <div class="insider-page__logo-container">
        <img
          src="/images/logos/insider-logo.png"
          alt="Insider Logo"
          class="insider-page__logo"
        />
        <div class="insider-page__title">Insider</div>
      </div>
      <p class="insider-page__intro-text">
        Welcome to your membership portal, {{ authUser.name }}!
      </p>
    </div>

    <div class="insider-page__announcment-container">
      <InsiderNotifications :notifications="recentNotifications" />
      <InsiderPromo
        :promo="keynotePromos.promo"
        :product="keynotePromos.product"
        @site-notification="$emit('site-notification', $event)"
      />
    </div>

    <h2
      class="insider-page__section-title"
      id="business-series-webinars"
      ref="business-series-webinars"
    >
      Business Series Webinars
    </h2>
    <InsiderCarousel
      :article-list="businessSeries"
      item-type="business-series-webinar"
      @product-selected="
        handleProductSelected(
          $event,
          'business-series-webinars',
          businessSeries
        )
      "
    />

    <h2
      class="insider-page__section-title"
      id="latest-economic-articles"
      ref="latest-economic-articles"
    >
      Latest Economic Articles
    </h2>
    <InsiderCarousel
      :article-list="latestEconomicArticles"
      item-type="latest-economic-articles"
      @product-selected="
        handleProductSelected(
          $event,
          'latest-economic-articles',
          latestEconomicArticles
        )
      "
    />

    <h2
      class="insider-page__section-title"
      id="executive-series-webinars"
      ref="executive-series-webinars"
    >
      Executive Series Webinars
    </h2>
    <InsiderCarousel
      :article-list="executiveSeries"
      item-type="executive-series-webinar"
      @product-selected="
        handleProductSelected(
          $event,
          'executive-series-webinars',
          latestEconomicArticles
        )
      "
    />

    <h2 class="insider-page__section-title" id="trendstalks" ref="trendstalks">
      TrendsTalk with ITR Economics
    </h2>
    <InsiderCarousel
      :article-list="trendsTalks"
      item-type="trends-talk"
      @product-selected="
        handleProductSelected($event, 'trendstalk', trendsTalks)
      "
    />

    <h2
      class="insider-page__section-title"
      id="recent-announcements"
      ref="recent-announcements"
    >
      Recent Announcements
    </h2>
    <InsiderCarousel
      :article-list="recentAnnouncements"
      item-type="recent-announcements"
      @product-selected="
        handleProductSelected(
          $event,
          'recent-announcement',
          recentAnnouncements
        )
      "
    />

    <h2 class="insider-page__section-title" id="itr-academy" ref="itr-academy">
      ITR Academy
    </h2>
    <InsiderCarousel
      :article-list="itrAcademy"
      item-type="itr-academy"
      @product-selected="
        handleProductSelected($event, 'itr-academy', itrAcademy)
      "
    />

    <h2
      class="insider-page__section-title"
      id="additional-resources"
      ref="additional-resources"
    >
      Additional Resources
    </h2>
    <div class="insider-page__additional-container">
      <AdditionalResourceComponent
        :resources="additionalResources"
        class="resources"
      />
      <div class="insider-page__store-container">
        <div class="insider-page__store-itr">
          <img
            src="/images/app-store-itr.png"
            alt="App Store ITR"
            class="insider-page__store-image"
          />
          <p class="insider-page__store-text">
            insider is on the itr ondemand app!
          </p>
        </div>
        <div class="insider-page__store-apps">
          <a
            href="https://play.google.com/store/apps/details?id=com.itrondemand.itrappdev&hl=en_US&gl=US"
            target="_blank"
          >
            <img
              src="/images/app-store-android-tr.png"
              alt="App Store Android"
              class="insider-page__app-image"
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/itr-ondemand/id1528665160"
            target="_blank"
          >
            <img
              src="/images/app-store-apple-tr.png"
              alt="App Store Apple"
              class="insider-page__app-image last"
            />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import InsiderCarousel from '~/components/insider/InsiderCarousel.vue';
  import AdditionalResourceComponent from '~/components/insider/AdditionalResourceComponent.vue';
  import InsiderNotifications from '~/components/insider/InsiderNotifications.vue';
  import InsiderPromo from '~/components/insider/InsiderPromo.vue';

  export default {
    name: 'insider-index-page',
    components: {
      InsiderCarousel,
      AdditionalResourceComponent,
      InsiderNotifications,
      InsiderPromo,
    },
    props: {
      authUser: {
        type: Object,
        required: true,
      },
      loadAssets: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      recentNotifications: [],
      businessSeries: [],
      executiveSeries: [],
      keynotePromos: [],
      latestEconomicArticles: [],
      trendsTalks: [],
      recentAnnouncements: [],
      itrAcademy: [],
      additionalResources: [],
      latestEconomicArticlesResponse: [],
      ref: null,
    }),
    async mounted() {
      try {
        const recentNotificationsResponse = await axios.get(
          '/insider/recent_notifications'
        );
        this.recentNotifications = recentNotificationsResponse.data;
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const keynotePromoResponse = await axios.get('/insider/keynote_promo');
        this.keynotePromos = keynotePromoResponse.data;
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const businessSeriesResponse = await axios.get(
          '/insider/webinar/business_series_webinar'
        );
        this.businessSeries = this.filterResults(businessSeriesResponse.data);
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const latestEconomicArticlesResponse = await axios.get(
          '/insider/latest_economic_articles'
        );
        this.latestEconomicArticles = this.filterResults(
          latestEconomicArticlesResponse.data
        );
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const executiveSeriesResponse = await axios.get(
          '/insider/webinar/executive_series_webinar'
        );
        this.executiveSeries = this.filterResults(executiveSeriesResponse.data);
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const trendsTalksResponse = await axios.get('/insider/trends_talks');
        this.trendsTalks = this.filterResults(trendsTalksResponse.data);
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const recentAnnouncementsResponse = await axios.get(
          '/insider/recent_announcements'
        );
        this.recentAnnouncements = recentAnnouncementsResponse.data;
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const itrAcademyResponse = await axios.get('/insider/itr_academy');
        this.itrAcademy = itrAcademyResponse.data;
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }

      try {
        const additionalResourcesResponse = await axios.get(
          '/insider/additional_resources'
        );
        this.additionalResources = additionalResourcesResponse.data;
      } catch (err) {
        // TODO: HANDLE ERROR - This is just silencing the error
      }
      if (window.location.href.includes('#')) {
        let urlArray = window.location.href.split('#');
        let ref = urlArray[urlArray.length - 1];
        this.ref = ref;
        let menuItem = this.getNavMenuItem(ref);
        const event = new CustomEvent('menu-clicked', {
          detail: {
            menuItem: menuItem,
          },
        });
        window.dispatchEvent(event);
      }
      if (this.ref) {
        const elementByRef = this.$refs[this.ref];
        const rect = elementByRef.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        window.scrollTo({
          top: top,
          behavior: 'smooth',
        });
      }
    },

    methods: {
      async handleProductSelected(product, productType, moreProducts) {
        if (productType.includes('webinars') && !product.purchased) {
          return (window.location.href = product.url);
        }
        if (productType.includes('webinars') && !product.vimeo_id) {
          return;
        }
        return (window.location.href = `/insider/${productType}/${product.slug}`);
      },

      filterResults(data) {
        return data.filter((product) => {
          return product.image;
        });
      },
      getNavMenuItem(productType) {
        switch (productType) {
          case 'business-series-webinars':
            return 'insider-business-series-webinars';
          case 'latest-economic-articles':
            return 'insider-latest-economic-articles';
          case 'executive-series-webinars':
            return 'insider-executive-series';
          case 'trendstalk':
            return 'insider-trends-talks';
          case 'recent-announcement':
            return 'insider-recent-announcements';
          case 'itr-academy':
            return 'insider-itr-academy';
          case 'additional-resources':
            return 'insider-additional-resources';
          default:
            return 'insider-home';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .insider-page {
    &__header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 2rem;
      z-index: 0;
      align-items: flex-start;
    }
    &__logo-container {
      display: flex;
      align-items: flex-end;
      gap: 1rem;
      width: 25%;
      @include screen-md {
        margin-right: 50px;
      }
    }
    &__logo {
      width: 48px;
      height: 48px;
    }
    &__title {
      font-size: 40px;
      font-weight: 700;
      margin-bottom: 5px;
      color: var(--itr-blue);
      visibility: hidden;
      @include screen-md {
        visibility: visible;
      }
    }
    &__section-title {
      margin: 0 0 1rem 0;
      font-size: 25px;
      font-weight: 700;
      @include screen-sm {
        font-size: 30px;
      }
      @include screen-lg {
        font-size: 35px;
      }
    }
    &__intro-text {
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      color: var(--itr-blue);
      text-align: right;
      line-height: 2rem;
      width: 75%;
      @include screen-sm {
        font-size: 20px;
      }
      @include screen-md {
        font-size: 25px;
      }
      @include screen-lg {
        font-size: 30px;
      }
    }

    &__announcment-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      width: 100%;
      height: 100%;
      margin-bottom: 2rem;
      @include screen-xl {
        flex-direction: row;
      }
    }
    &__additional-container {
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 2rem;
      justify-content: center;
      @include screen-xl {
        flex-direction: row;
        align-items: center;
      }
      .resources {
        flex-grow: 1;
      }
    }
    &__store-container {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      gap: 2rem;
    }
    &__store-itr {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      gap: 6px;
      @include screen-sm {
        gap: 20px;
      }
    }
    &__store-image {
      width: 68px;
      height: 68px;
      @include screen-sm {
        width: 90px;
        height: 90px;
      }
      @include screen-md {
        height: 107px;
        width: 107px;
      }
    }
    &__store-text {
      color: var(--itr-green-mid);
      max-width: 180px;
      font-weight: 600;
      font-size: 14px;
      text-transform: uppercase;
      text-align: center;
      line-height: 1.2;
    }
    &__store-apps {
      display: flex;
      flex-direction: column;
    }
    &__app-image {
      width: 200px;
      @include screen-sm {
        width: 229px;
      }
      @include screen-md {
        width: 275px;
      }
    }
    &__app-image.last {
      margin-top: -5px;
    }
  }

  @include screen-lg {
    .insider-page {
      &__header {
        flex-direction: row;
      }
    }
  }
</style>
